export enum TaskState {
  "UNASSIGNED" = "UNASSIGNED",
  "ASSIGNED" = "ASSIGNED",
  "COMPLETED" = "COMPLETED",
  "CLOSED" = "CLOSED",
  "INVALID" = "INVALID",
  "PLANNED" = "PLANNED",
}
